export interface Toggleable {
  toggleServiceKey?: string | string[];
}
